import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { HospiceReferral } from "../../../../../../../models/hospice-referral";
import { Patient } from "../../../../../../../models/patient";
import { formatDate } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";
import { CurrentUserService } from "../../../../../../../services/current-user-service";
import { ToastrService } from "../../../../../../../services/toastr.service";
import { ReferralService } from "../../../../../../../services/referral-service";

import TablePrompt from "../../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";

export default defineComponent({
    components: {
        TablePrompt
    },
    props: {
        resetList: {
            type: Function
        },
        referralId: {
            type: String,
            default: ""
        },
        columns: {
            type: Number
        },
        isReferral: {
            type: Boolean,
            default: false
        },
        note: {
            type: Object
        },
        referral: {
            type: HospiceReferral || Patient
        }
    },

    data(vm) {
        return {
            _currentUsersService: null,
            _referralService: null,
            _toastrService: null,
            currentUser: null,
            isDeleteRequested: false,
            isEditRequested: false,
            isViewRequested: false,
            isDeleteInProgress: false,
            formatDate
        };
    },

    created() {
        this._currentUsersService = Container.instance.get(CurrentUserService);
        this._toastrService = Container.instance.get(ToastrService);
        this._referralService = Container.instance.get(ReferralService);
    },
    async mounted() {
        this.currentUser = await this._currentUsersService.getUser();
    },
    methods: {
        openEditNote() {
            this.isEditRequested = true;
        },
        openViewNote() {
            this.isViewRequested = true;
        },
        confirmDeleteNote() {
            this.isDeleteRequested = true;
        },
        closeViewNote() {
            this.isViewRequested = false;
        },
        closeEditNote() {
            this.isEditRequested = false;
        },
        cancelDeleteNote() {
            this.isDeleteRequested = false;
        }
    }
});
